import { memo } from "react"

import { useGeolocation } from "../../hooks/utils"
import { Colors } from "../../utils/colors"
import { Marker } from "../components"

export const CurrentLocationMarker = memo(() => {
	const coordinates = useGeolocation()

	return (
		coordinates.latitude &&
		coordinates.longitude && (
			<Marker longitude={coordinates.longitude} latitude={coordinates.latitude}>
				<svg className="cursor-pointer" width="18" height="18">
					<circle cx="9" cy="9" r="8" fill={Colors.blue} strokeWidth="2" stroke="var(--base-12)" />
				</svg>
			</Marker>
		)
	)
})
CurrentLocationMarker.displayName = "CurrentLocationMarker"
